import React from 'react'
import PropTypes from 'prop-types'
import LeadItem from "./LeadItem"

LeadBody.propTypes = {
    error: PropTypes.string,
    listLead: PropTypes.array
}

function LeadBody(props) {
    const {error, listLead} = props

    return (
        <tbody className="CustomersBody">
        {
            !!listLead && listLead.length > 0 ? listLead.map((item, index) => (
                <LeadItem {...props} key={index} index={index} item={item}/>
            )) : <tr className="NoRecord">
                <td colSpan={5}>Không có bản ghi nào.</td>
            </tr>
        }

        {
            !!error && error.length > 0 && <tr className="NoRecord Error">
                <td colSpan={5}>{error}</td>
            </tr>
        }
        </tbody>
    )
}

export default LeadBody